/**
 * Task Services Module
 * Exports all task management services and factory functions
 */
// Service exports
export * from './TaskService';
export * from './TaskStreamingService';
export * from './TaskStatusService';
export * from './TaskPriorityService';
export * from './TaskProgressStageService';
export * from './TaskAssignmentService';
export * from './TaskAttachmentService';
export * from './TaskCommentService';
export * from './TaskRecurrenceService';
export * from './TaskNoteService';
export * from './TaskLogService';
export * from './LogTypeService';
export * from './TaskNotificationService';
export * from './TaskNotificationQueueService';
export * from './TaskReportService';
export * from './TaskSettingsService';
export * from './TaskNotificationChannelService';
export * from './TaskEscalationContactService';
// Service imports for factory
import { TaskService } from './TaskService';
import { TaskStreamingService } from './TaskStreamingService';
import { TaskStatusService } from './TaskStatusService';
import { TaskPriorityService } from './TaskPriorityService';
import { TaskProgressStageService } from './TaskProgressStageService';
import { TaskAssignmentService } from './TaskAssignmentService';
import { TaskAttachmentService } from './TaskAttachmentService';
import { TaskCommentService } from './TaskCommentService';
import { TaskRecurrenceService } from './TaskRecurrenceService';
import { TaskNoteService } from './TaskNoteService';
import { TaskLogService } from './TaskLogService';
import { LogTypeService } from './LogTypeService';
import { TaskNotificationService } from './TaskNotificationService';
import { TaskNotificationQueueService } from './TaskNotificationQueueService';
import { TaskReportService } from './TaskReportService';
import { TaskSettingsService } from './TaskSettingsService';
import { TaskNotificationChannelService } from './TaskNotificationChannelService';
import { TaskEscalationContactService } from './TaskEscalationContactService';
/**
 * Create all task services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all task service instances
 */
export function createTaskServices(http, config) {
    return {
        task: new TaskService(http, config),
        taskStreaming: new TaskStreamingService(http),
        taskStatus: new TaskStatusService(http, config),
        taskPriority: new TaskPriorityService(http, config),
        taskProgressStage: new TaskProgressStageService(http, config),
        taskAssignment: new TaskAssignmentService(http, config),
        taskAttachment: new TaskAttachmentService(http, config),
        taskComment: new TaskCommentService(http, config),
        taskRecurrence: new TaskRecurrenceService(http, config),
        taskNote: new TaskNoteService(http, config),
        taskLog: new TaskLogService(http, config),
        logType: new LogTypeService(http, config),
        taskNotification: new TaskNotificationService(http, config),
        taskNotificationQueue: new TaskNotificationQueueService(http, config),
        taskReport: new TaskReportService(http, config),
        taskSettings: new TaskSettingsService(http, config),
        taskNotificationChannel: new TaskNotificationChannelService(http, config),
        taskEscalationContact: new TaskEscalationContactService(http, config),
    };
}
//# sourceMappingURL=index.js.map